import riot from 'riot';
import { getSmartkits as libGetSmartkits, getLessons as libGetLessons } from '../src/lib.js';
riot.tag2('smartkits', '<div class="container is-fluid has-text-centered" show="{loading}"> <progress class="progress is-large" max="100">60%</progress> </div> <div class="column is-12" style="margin-top: 5px;"> <section class="hero is-dark"> <div class="hero-body"> <div class="container"> <h1 class="title"> Filament Lessons Library </h1> <h2 class="subtitle"> All the lesson plans you can teach with your Filament kit! </h2> </div> </div> </section> <div class="container is-fluid has-text-centered" show="{loading_lessons}" style="margin-top: 5px;"> <span class="button is-outlined is-rounded is-large is-danger is-loading">Loading</span> </div> <div class="columns is-multiline" if="{!loading_lessons}" style="margin-top: 5px;"> <div class="column is-4" each="{l in lessons}" if="{!lessons_error}"> <div class="card" style="display:flex; flex-direction:column; height:100%;"> <div class="card-content"> <div class="media"> <div class="media-left"> <figure class="image is-48x48"> <img src="img/smartkits.png" alt="Smartkits Icon"> </figure> </div> <div class="media-content"> <p class="title is-4">{l.name}</p> <p class="subtitle is-6">{l.fun}</p> </div> </div> <div class="content"> {l.description} <article class="message is-primary" style="margin-top: .75rem;"> <div class="message-header"> <p>State Standards</p> </div> <div class="message-body"> <div class="tags"> <span class="tag is-info" each="{s in l && l.standards ? l.standards : []}">{s.name}</span> </div> </div> </article> </div> </div> </div> </div> <div class="column is-12" if="{lessons_error}"> Shucks, there was an error getting the lessons </div> </div> </div> <div class="column is-12" style="margin-top: 5px;"> <section class="hero is-dark"> <div class="hero-body"> <div class="container"> <h1 class="title" if="{!user}"> Please login to see your kits! </h1> <h1 class="title" if="{user}"> Your Kits! </h1> <h2 class="subtitle"> These are all the kits you have registered </h2> </div> </div> </section> <div class="container is-fluid has-text-centered" show="{loading_smartkits}" style="margin-top: 5px;"> <span class="button is-outlined is-rounded is-large is-danger is-loading">Loading</span> </div> <div class="columns is-multiline" if="{user && !loading_smartkits}" style="margin-top: 5px;"> <div class="column is-4" each="{d in devices}" if="{!devices_error}"> <div class="card"> <div class="card-content"> <div class="media"> <div class="media-left"> <figure class="image is-48x48"> <img src="img/smartkits.png" alt="Smartkits Icon"> </figure> </div> <div class="media-content"> <p class="title is-4">Name: {d.device_name}</p> <p class="subtitle is-6">Id: {d.device_id}</p> </div> </div> <div class="content"> <br> <time datetime="2016-1-1">Last viewed 11:09 PM - 1 Jan 2020</time> </div> </div> <footer class="card-footer"> <a href="#" class="card-footer-item">Assign Lesson</a> <a href="#" class="card-footer-item">Students</a> </footer> </div> </div> <div class="column is-12" if="{devices_error}"> Shucks, there was an error getting your kits. </div> </div> </div>', '', '', function(opts) {
        var self = this;
        self.loading_smartkits = true;
        self.loading_lessons = true;

        self.on('mount', function() {
            getLessons();
            getUser();
            if (self.user) {
                getSmartkits();
            }
        });

        self.opts.eventBus.on('userLogin', function() {
            getSmartkits();
            getLessons();
            getUser();

            routerHelpers.navigate('activities');
        });

        this.getStatusTag = function(s) {
            if (s == "Inactive") {
                return "light"
            } else if (s == "Error") {
                return "danger"
            } else if (s == "In Unit") {
                return "success"
            } else {
                return "warning"
            }
        }.bind(this)

        function getUser() {
            user_profile = localStorage.getItem('profile');
            if (user_profile != "undefined") {
                self.update({
                    user: JSON.parse(user_profile)
                });
            }
        };

        function getSmartkits() {
            self.loading_smartkits = true;
            libGetSmartkits().then(function(res) {
                self.loading_smartkits = false;
                self.update({
                    devices: res['data']['devices'],
                    devices_error: undefined
                });
            }).catch(function(error) {
                console.error('Smartkits Error:' + error);
                self.loading_smartkits = false;
                self.update({
                    devices: [],
                    devices_error: error
                });
            });
        }

        function getLessons() {
            self.loading_lessons = true;
            libGetLessons().then(function(res) {
                self.loading_lessons = false;
                self.update({
                    lessons: res['data']['lessons'],
                    lessons_error: undefined
                });
            }).catch(function(error) {
                console.error('Lessons Error:' + error);
                self.loading_lessons = false;
                self.update({
                    lessons: [],
                    lessons_error: error
                });
            });

        }
});
